/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsSerialNumberHistory
 */
export interface ControlcenterMelcoModelsSerialNumberHistory {
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    history_type?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    computer_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    operating_system?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    version_number?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    created_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsSerialNumberHistory
     */
    comments?: string | null;
}

export function ControlcenterMelcoModelsSerialNumberHistoryFromJSON(json: any): ControlcenterMelcoModelsSerialNumberHistory {
    return ControlcenterMelcoModelsSerialNumberHistoryFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsSerialNumberHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsSerialNumberHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'history_type': !exists(json, 'history_type') ? undefined : json['history_type'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'computer_name': !exists(json, 'computer_name') ? undefined : json['computer_name'],
        'operating_system': !exists(json, 'operating_system') ? undefined : json['operating_system'],
        'version_number': !exists(json, 'version_number') ? undefined : json['version_number'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
    };
}

export function ControlcenterMelcoModelsSerialNumberHistoryToJSON(value?: ControlcenterMelcoModelsSerialNumberHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'history_type': value.history_type,
        'user_name': value.user_name,
        'computer_name': value.computer_name,
        'operating_system': value.operating_system,
        'version_number': value.version_number,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'comments': value.comments,
    };
}


